import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate, matchPath } from "react-router-dom";

import SideBar from "../../components/SideBar/SideBar";
import TopNavbar from "../../components/SideBar/TopNavbar";

import Dashboard from "../../pages/AdminDashboard/Dashboard";
import Home from "../../pages/AdminDashboard/Home/Home";
import TeacherDash from "../../pages/AdminDashboard/Ad-TeacherDashboard/TeacherDash";
import Notification from "../../pages/AdminDashboard/Notification/Notification";
import AllNotification from "../../pages/AdminDashboard/Notification/AllNotification";
import NewNotification from "../../pages/AdminDashboard/Notification/NewNotification";
import UnreadNotification from "../../pages/AdminDashboard/Notification/UnreadNotification";
import OnlineTutoring from "../../pages/AdminDashboard/Ad-TeacherDashboard/OnlineTutoring";
import HomeTutoring from "../../pages/AdminDashboard/Ad-TeacherDashboard/HomeTutoring";
import TeacherMessage from "../../pages/AdminDashboard/Ad-TeacherDashboard/TeacherMessage";
import TeacherReport from "../../pages/AdminDashboard/Ad-TeacherDashboard/TeacherReport";
import Teacher from "../../pages/AdminDashboard/Ad-TeacherDashboard/Teacher";
import TeacherProfile from "../../pages/AdminDashboard/Ad-TeacherDashboard/TeacherProfile";
import TeacherPayment from "../../pages/AdminDashboard/Ad-TeacherDashboard/TeacherPayment";
import HomeTeacher from "../../pages/AdminDashboard/HomeTeacher/HomeTeacher";
import Report from "../../pages/AdminDashboard/Report/Report";
import TeacherNotification from "../../pages/AdminDashboard/Ad-TeacherDashboard/TeacherNotification";
import TeacherNewNotification from "../../pages/AdminDashboard/Ad-TeacherDashboard/TeacherNewNoti";
import TeacherUnreadNotification from "../../pages/AdminDashboard/Ad-TeacherDashboard/TeacherUnreadNoti";
import Error404 from "../../pages/AdminDashboard/Error404";
import OnlineClasses from "../../pages/AdminDashboard/OnlineTutoring/OnlineClasses";
import TeacherChat from "../../pages/AdminDashboard/Ad-TeacherDashboard/TeacherChat";
import TeacherStartClass from "../../pages/AdminDashboard/Ad-TeacherDashboard/TeacherStartClass";
import Student from "../../pages/AdminDashboard/Ad-StudentDashboard/Student";
import StudentDash from "../../pages/AdminDashboard/Ad-StudentDashboard/StudentDash";
import StudentTution from "../../pages/AdminDashboard/Ad-StudentDashboard/StudentTution";
import FindTeacher from "../../pages/AdminDashboard/Ad-StudentDashboard/FindTeacher";
import HomeTeacherList from "../../pages/AdminDashboard/Ad-StudentDashboard/HomeTeacherList";
import OnlineTeacherList from "../../pages/AdminDashboard/Ad-StudentDashboard/OnlineTeacherList";
import HomeTution from "../../pages/AdminDashboard/Ad-StudentDashboard/HomeTution";
import TeacherPortfolio from "../../pages/AdminDashboard/Ad-StudentDashboard/TeacherPortfolio";
import StuProfile from "../../pages/AdminDashboard/Ad-StudentDashboard/StuProfile";
import StudentPayment from "../../pages/AdminDashboard/Ad-StudentDashboard/StudentPayment";
import PaymentDetail from "../../pages/AdminDashboard/Ad-StudentDashboard/PaymentDetail";
import StudentNotification from "../../pages/AdminDashboard/Ad-StudentDashboard/StudentNotification";
import StudentNewNotification from "../../pages/AdminDashboard/Ad-StudentDashboard/StudentNewNoti";
import StudentUnreadNotification from "../../pages/AdminDashboard/Ad-StudentDashboard/StudentUnreadNoti";
import TeacherPortfolio2 from "../../pages/AdminDashboard/Ad-StudentDashboard/TeacherPortfolio2";
import HomeTeacherPortfolio from "../../pages/AdminDashboard/Ad-StudentDashboard/HomeTeacherPortfolio";
import HomeTeacherPortfolio2 from "../../pages/AdminDashboard/Ad-StudentDashboard/HomeTeacherPortfolio2";
import MyAccount from "../../pages/AdminDashboard/Setting/MyAccount";
import WebsiteSetting from "../../pages/AdminDashboard/Setting/WebsiteSetting";
import NotificationSetting from "../../pages/AdminDashboard/Setting/NotificationSetting";
import EmailTemplate from "../../pages/AdminDashboard/Setting/EmailTemplate";
import TeacherPaymentDetail from "../../pages/AdminDashboard/Ad-TeacherDashboard/TeacherPaymentDetail";
import AcademicClass from "../../pages/AdminDashboard/AcademicZone/AcademicClass";
import AcademicSubject from "../../pages/AdminDashboard/AcademicZone/AcademicSubject";
import AcademicSkill from "../../pages/AdminDashboard/AcademicZone/AcademicSkill";
import AcademicLanguage from "../../pages/AdminDashboard/AcademicZone/AcademicLanguage";
import DemoClass from "../../pages/AdminDashboard/AcademicZone/DemoClass";
import Upcoming from "../../pages/AdminDashboard/Meetings/Upcoming";
import Completed from "../../pages/AdminDashboard/Meetings/Completed";
import StudentChat from "../../pages/AdminDashboard/Ad-StudentDashboard/StudentChat";
import AdminAddSubject from "../../pages/AdminDashboard/Ad-TeacherDashboard/AdminAddSubject";
import KnowledgeBase from "../../pages/AdminDashboard/KnowledgeBase/KnowledgeBase";
import KidsAdmin from "../../pages/AdminDashboard/Kids/KidsAdmin";
import Translations from "../../pages/AdminDashboard/Translations/Translations";

function AdminLayout() {
  const { pathname } = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();

  // Approx. TopNavbar height; adjust if needed
  const HEADER_PX = 64;

  // Only these routes should force the content area to be full-height with inner scroll
  const FULL_HEIGHT_ROUTES = [
    "/admins/mentor-chat",
    "/admins/mentee-chat",

    "/admins/upcoming",
    "/admins/completed",
    "/admins/teacher-start-class",
  ];

  const wantsFullHeight = FULL_HEIGHT_ROUTES.some((pattern) =>
    matchPath({ path: pattern, end: false }, pathname)
  );

  const toggleSidebar = () => {
    if (window.innerWidth <= 1024) setIsSidebarOpen((s) => !s);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth > 1024);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    const raw = localStorage.getItem("edo-admin");
    if (!raw) { navigate("/"); return; }
    try {
      const user = JSON.parse(raw);
      if (Number(user.admin?.role_id) === 6) { navigate("/school/dashboard"); return; }
    } catch { navigate("/"); }
  }, [navigate, pathname]);

  return (
    <div className="min-h-screen w-full bg-white">
      {/* Slim brand ribbon in your theme colors (remove if not needed) */}
      <div className="h-1 w-full bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]" />

      <TopNavbar toggleSidebar={toggleSidebar} />

      {/* Main row: no extra borders/radius; inner pages own their chrome */}
      <div className={`flex ${wantsFullHeight ? `h-[calc(100vh-${HEADER_PX}px)] overflow-hidden` : ""}`}>
        <SideBar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

        {/* Content area: just spacing, no card wrapper */}
        <main
          className={`${
            wantsFullHeight ? "flex-1 h-full min-h-0 overflow-hidden" : "flex-1"
          } w-full px-3 md:px-4 lg:px-6 py-4`}
        >
          <Routes>
            {/* Notification */}
            <Route path="/notification" element={<Notification />} />
            <Route path="/all-notification" element={<AllNotification />} />
            <Route path="/new-notification" element={<NewNotification />} />
            <Route path="/unread-notification" element={<UnreadNotification />} />

            {/* Home / Dashboards */}
            {/* <Route path="" element={<Dashboard />} /> */}
            <Route path="/home" element={<Home />} />
            <Route path="/mentor-dash" element={<TeacherDash />} />
            <Route path="/mentee-dash" element={<StudentDash />} />

            {/* Online / Meetings (full-height candidates listed above) */}
            <Route path="/sessions" element={<OnlineClasses />} />
            <Route path="/upcoming" element={<Upcoming />} />
            <Route path="/completed" element={<Completed />} />
            <Route path="/teacher-start-class" element={<TeacherStartClass />} />

            {/* Teacher */}
            <Route path="/mentor" element={<Teacher />} />
            <Route path="/online-sessions" element={<OnlineTutoring />} />
            <Route path="/home-tutoring" element={<HomeTutoring />} />
            <Route path="/mentor-message" element={<TeacherMessage />} />
            <Route path="/teacher-report" element={<TeacherReport />} />
            <Route path="/teacher-profile" element={<TeacherProfile />} />
            <Route path="/teacher-payment" element={<TeacherPayment />} />
            <Route path="/teacher-payment-detail" element={<TeacherPaymentDetail />} />
            <Route path="/teacher-notification" element={<TeacherNotification />} />
            <Route path="/teacher-new-noti" element={<TeacherNewNotification />} />
            <Route path="/teacher-unread-noti" element={<TeacherUnreadNotification />} />
            <Route path="/mentor-chat" element={<TeacherChat />} />

            {/* Student */}
            <Route path="/mentee" element={<Student />} />
            <Route path="/mentee-tution" element={<StudentTution />} />
            <Route path="/find-teacher" element={<FindTeacher />} />
            <Route path="/home-teacher-list" element={<HomeTeacherList />} />
            <Route path="/home-tution" element={<HomeTution />} />
            <Route path="/online-mentor-list" element={<OnlineTeacherList />} />
            <Route path="/mentee-chat" element={<StudentChat />} />
            <Route path="/edit-subject" element={<AdminAddSubject />} />
            <Route path="/home-teacher-portfolio" element={<HomeTeacherPortfolio />} />
            <Route path="/home-teacher-portfolio-2" element={<HomeTeacherPortfolio2 />} />
            <Route path="/mentor-portfolio" element={<TeacherPortfolio />} />
            <Route path="/mentor-portfolio-2" element={<TeacherPortfolio2 />} />
            <Route path="/student-profile" element={<StuProfile />} />
            <Route path="/student-payment" element={<StudentPayment />} />
            <Route path="/payment-detail" element={<PaymentDetail />} />
            <Route path="/student-notification" element={<StudentNotification />} />
            <Route path="/student-new-noti" element={<StudentNewNotification />} />
            <Route path="/student-unread-noti" element={<StudentUnreadNotification />} />

            {/* Academic Zone */}
            <Route path="/add-profession" element={<AcademicClass />} />
            <Route path="/specialization" element={<AcademicSubject />} />
            <Route path="/ac-skill" element={<AcademicSkill />} />
            <Route path="/ac-language" element={<AcademicLanguage />} />
            <Route path="/durations" element={<DemoClass />} />

            {/* Report */}
            <Route path="/report" element={<Report />} />

            {/* Settings */}
            <Route path="/my-account" element={<MyAccount />} />
            <Route path="/web-setting" element={<WebsiteSetting />} />
            <Route path="/setting-noti" element={<NotificationSetting />} />
            <Route path="/email-template" element={<EmailTemplate />} />

            {/* Knowledge Base */}
            <Route path="/knowledge" element={<KnowledgeBase />} />

            {/* Translations */}
            <Route path="/translations" element={<Translations />} />

            {/* Kids Zone */}
            <Route path="/kids" element={<KidsAdmin />} />

            {/* Error */}
            <Route path="/error" element={<Error404 />} />

            {/* Kebab-case migration redirects — keep old bookmarks/links working */}
            <Route path="/allNotification" element={<Navigate to="/admins/all-notification" replace />} />
            <Route path="/newNotification" element={<Navigate to="/admins/new-notification" replace />} />
            <Route path="/unreadNotification" element={<Navigate to="/admins/unread-notification" replace />} />
            <Route path="/mentorDash" element={<Navigate to="/admins/mentor-dash" replace />} />
            <Route path="/menteeDash" element={<Navigate to="/admins/mentee-dash" replace />} />
            <Route path="Sessions" element={<Navigate to="/admins/sessions" replace />} />
            <Route path="/teacherStartClass" element={<Navigate to="/admins/teacher-start-class" replace />} />
            <Route path="/onlineSessions" element={<Navigate to="/admins/online-sessions" replace />} />
            <Route path="/homeTutoring" element={<Navigate to="/admins/home-tutoring" replace />} />
            <Route path="/mentorMessage" element={<Navigate to="/admins/mentor-message" replace />} />
            <Route path="/teacherReport" element={<Navigate to="/admins/teacher-report" replace />} />
            <Route path="/teacherProfile" element={<Navigate to="/admins/teacher-profile" replace />} />
            <Route path="/teacherPayment" element={<Navigate to="/admins/teacher-payment" replace />} />
            <Route path="/teacherPaymentDetail" element={<Navigate to="/admins/teacher-payment-detail" replace />} />
            <Route path="/teacherNotification" element={<Navigate to="/admins/teacher-notification" replace />} />
            <Route path="/teacherNewNoti" element={<Navigate to="/admins/teacher-new-noti" replace />} />
            <Route path="/teacherUnreadNoti" element={<Navigate to="/admins/teacher-unread-noti" replace />} />
            <Route path="/mentorChat" element={<Navigate to="/admins/mentor-chat" replace />} />
            <Route path="/menteeTution" element={<Navigate to="/admins/mentee-tution" replace />} />
            <Route path="/findTeacher" element={<Navigate to="/admins/find-teacher" replace />} />
            <Route path="/homeTeacherList" element={<Navigate to="/admins/home-teacher-list" replace />} />
            <Route path="/homeTution" element={<Navigate to="/admins/home-tution" replace />} />
            <Route path="/onlineMentorList" element={<Navigate to="/admins/online-mentor-list" replace />} />
            <Route path="/menteeChat" element={<Navigate to="/admins/mentee-chat" replace />} />
            <Route path="/editsubject" element={<Navigate to="/admins/edit-subject" replace />} />
            <Route path="/homeTeacherPortfolio" element={<Navigate to="/admins/home-teacher-portfolio" replace />} />
            <Route path="/homeTeacherPortfolio2" element={<Navigate to="/admins/home-teacher-portfolio-2" replace />} />
            <Route path="/mentorPortfolio" element={<Navigate to="/admins/mentor-portfolio" replace />} />
            <Route path="/mentorPortfolio2" element={<Navigate to="/admins/mentor-portfolio-2" replace />} />
            <Route path="/studentProfile" element={<Navigate to="/admins/student-profile" replace />} />
            <Route path="/studentPayment" element={<Navigate to="/admins/student-payment" replace />} />
            <Route path="/paymentDetail" element={<Navigate to="/admins/payment-detail" replace />} />
            <Route path="/studentNotification" element={<Navigate to="/admins/student-notification" replace />} />
            <Route path="/studentNewNoti" element={<Navigate to="/admins/student-new-noti" replace />} />
            <Route path="/studentUnreadNoti" element={<Navigate to="/admins/student-unread-noti" replace />} />
            <Route path="/addProfession" element={<Navigate to="/admins/add-profession" replace />} />
            <Route path="/acSkill" element={<Navigate to="/admins/ac-skill" replace />} />
            <Route path="/acLanguage" element={<Navigate to="/admins/ac-language" replace />} />
            <Route path="/myAccount" element={<Navigate to="/admins/my-account" replace />} />
            <Route path="/webSetting" element={<Navigate to="/admins/web-setting" replace />} />
            <Route path="/settingNoti" element={<Navigate to="/admins/setting-noti" replace />} />
            <Route path="/emailTemplate" element={<Navigate to="/admins/email-template" replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default AdminLayout;
